import Auth from '../modules/Authentication'
import { apiUrl } from '../variables/index'
import { handleErrors, handleResponse } from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Sessions {
  constructor() {
    this.auth = new Auth()
  }

  list = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}rules/`, { headers }).then(handleErrors).then(handleResponse)
  }

  override = (data) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}override/`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
}
